<template>
  <svg
    width="16px"
    height="17px"
    viewBox="0 0 16 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>下载</title>
    <desc>Created with Sketch.</desc>
    <g id="订单" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="2-1-订单中心-配件"
        transform="translate(-1548.000000, -222.000000)"
      >
        <g id="编组" transform="translate(1546.000000, 220.000000)">
          <g id="下载" transform="translate(0.000000, 0.500000)">
            <rect
              id="矩形"
              fill="#FFFFFF"
              opacity="0"
              transform="translate(10.000000, 10.000000) scale(1, -1) translate(-10.000000, -10.000000) "
              x="0"
              y="0"
              width="20"
              height="20"
            ></rect>
            <path
              d="M16.0301538,10.2178462 L10.5033846,4.65476923 C10.3809231,4.53169231 10.2209231,4.47261538 10.0615385,4.47384615 C10.04,4.472 10.0215385,4.46153846 10,4.46153846 C9.91015385,4.46153846 9.82646154,4.48246154 9.74953846,4.51692308 C9.672,4.54646154 9.59815385,4.59138462 9.53538462,4.65415385 L4.54830769,9.63261538 C4.30769231,9.87261538 4.30707692,10.2621538 4.54769231,10.5027692 C4.66769231,10.6233846 4.82523077,10.6836923 4.98338462,10.6836923 C5.14092308,10.6836923 5.29784615,10.6233846 5.41846154,10.504 L9.38461538,6.544 L9.38461538,17.3846154 C9.38461538,17.7249231 9.66030769,18 10,18 C10.3396923,18 10.6153846,17.7249231 10.6153846,17.3846154 L10.6153846,6.51384615 L15.1575385,11.0855385 C15.2775385,11.2061538 15.4363077,11.2670769 15.5938462,11.2670769 C15.7513846,11.2670769 15.9076923,11.2073846 16.0276923,11.088 C16.2695385,10.8486154 16.2701538,10.4584615 16.0301538,10.2178462 Z M16.7692308,3.23076923 L3.23076923,3.23076923 C2.89107692,3.23076923 2.61538462,2.95507692 2.61538462,2.61538462 C2.61538462,2.27569231 2.89107692,2 3.23076923,2 L16.7692308,2 C17.1095385,2 17.3846154,2.27569231 17.3846154,2.61538462 C17.3846154,2.95507692 17.1095385,3.23076923 16.7692308,3.23076923 Z"
              id="形状备份"
              fill="currentColor"
              fill-rule="nonzero"
              transform="translate(10.000000, 10.000000) scale(1, -1) translate(-10.000000, -10.000000) "
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Download'
});
</script>
